export const STATUSES = [
    "Baru",
    "Diproses",
    "Dalam Pengantaran",
    "Selesai",
    "Dibatalkan",
];

export const STATUS_STYLES = {
    Baru: "bg-brand-mist text-brand",
    Diproses: "bg-amber-100 text-amber-700",
    "Dalam Pengantaran": "bg-indigo-100 text-indigo-700",
    Selesai: "bg-emerald-100 text-emerald-700",
    Dibatalkan: "bg-red-100 text-red-600",
};

export function mapsPointLink(lat, lng) {
    return `https://www.google.com/maps?q=${lat},${lng}`;
}
